var map = {
	"./Airplane_French_Avion.mp3": 28149,
	"./Airplane_German_Flugzeug.mp3": 78215,
	"./Airplane_Italian_Aereo.mp3": 72206,
	"./Airplane_Polish_Samolot.mp3": 26054,
	"./Airplane_Portuguese_Avião.mp3": 9155,
	"./Airplane_Spanish_Avión.mp3": 27211,
	"./Almond_French_Amande.mp3": 31833,
	"./Almond_German_Mandel.mp3": 90502,
	"./Almond_Italian_Mandorla.mp3": 26725,
	"./Almond_Polish_Migdał.mp3": 91232,
	"./Almond_Portuguese_Amêndoa.mp3": 35656,
	"./Almond_Spanish_Almendra.mp3": 81219,
	"./Ankle_French_Cheville.mp3": 93441,
	"./Ankle_German_Knöchel.mp3": 2354,
	"./Ankle_Italian_Caviglia.mp3": 66691,
	"./Ankle_Polish_Kostka.mp3": 28978,
	"./Ankle_Portuguese_Tornozelo.mp3": 58616,
	"./Ankle_Spanish_Tobillo.mp3": 59706,
	"./Apple_French_Pomme.mp3": 42168,
	"./Apple_German_Apfel.mp3": 4772,
	"./Apple_Italian_Mela.mp3": 27491,
	"./Apple_Polish_Jabłko.mp3": 86918,
	"./Apple_Portuguese_Maçã.mp3": 38491,
	"./Apple_Spanish_Manzana.mp3": 24820,
	"./Apron_French_Tablier.mp3": 5047,
	"./Apron_German_Schürze.mp3": 20059,
	"./Apron_Italian_Grembiule.mp3": 75210,
	"./Apron_Polish_Fartuch.mp3": 60802,
	"./Apron_Portuguese_Avental.mp3": 33934,
	"./Apron_Spanish_Delantal.mp3": 34441,
	"./Arm_French_Bras.mp3": 39152,
	"./Arm_German_Arm.mp3": 66576,
	"./Arm_Italian_Braccio.mp3": 10245,
	"./Arm_Polish_Ramię.mp3": 65873,
	"./Arm_Portuguese_Braço.mp3": 67408,
	"./Arm_Spanish_Brazo.mp3": 23058,
	"./Art_French_Art.mp3": 66172,
	"./Art_German_Kunst.mp3": 99810,
	"./Art_Italian_Arte.mp3": 51359,
	"./Art_Polish_Sztuka.mp3": 38030,
	"./Art_Portuguese_Arte.mp3": 10556,
	"./Art_Spanish_Arte.mp3": 44069,
	"./Baby_French_Bébé.mp3": 30254,
	"./Baby_German_Baby.mp3": 56520,
	"./Baby_Italian_Bambino.mp3": 34354,
	"./Baby_Polish_Dziecko.mp3": 89596,
	"./Baby_Portuguese_Bebê.mp3": 64272,
	"./Baby_Spanish_Bebé.mp3": 73740,
	"./Bag_French_Sac.mp3": 83295,
	"./Bag_German_Tasche.mp3": 26928,
	"./Bag_Italian_Borsa.mp3": 10275,
	"./Bag_Polish_Torba.mp3": 88991,
	"./Bag_Portuguese_Bolsa.mp3": 56856,
	"./Bag_Spanish_Bolsa.mp3": 39673,
	"./Ball_French_Balle.mp3": 11307,
	"./Ball_German_Ball.mp3": 63028,
	"./Ball_Italian_Palla.mp3": 45513,
	"./Ball_Polish_Piłka.mp3": 71477,
	"./Ball_Portuguese_Bola.mp3": 49331,
	"./Ball_Spanish_Pelota.mp3": 33574,
	"./Balloon_French_Ballon.mp3": 60647,
	"./Balloon_German_Ballon.mp3": 18657,
	"./Balloon_Italian_Palloncino.mp3": 38452,
	"./Balloon_Polish_Balon.mp3": 20504,
	"./Balloon_Portuguese_Balão.mp3": 24181,
	"./Balloon_Spanish_Globo.mp3": 20712,
	"./Bathroom_French_Salle de bain.mp3": 34468,
	"./Bathroom_German_Badezimmer.mp3": 7428,
	"./Bathroom_Italian_Bagno.mp3": 6441,
	"./Bathroom_Polish_Łazienka.mp3": 41785,
	"./Bathroom_Portuguese_Banheiro.mp3": 96227,
	"./Bathroom_Spanish_Baño.mp3": 37145,
	"./Bear_French_Ours.mp3": 7937,
	"./Bear_German_Bär.mp3": 8478,
	"./Bear_Italian_Orso.mp3": 13227,
	"./Bear_Polish_Niedźwiedź.mp3": 67740,
	"./Bear_Portuguese_Urso.mp3": 22046,
	"./Bear_Spanish_Oso.mp3": 68867,
	"./Bed_French_Lit.mp3": 39670,
	"./Bed_German_Bett.mp3": 32582,
	"./Bed_Italian_Letto.mp3": 90605,
	"./Bed_Polish_Łóżko.mp3": 99792,
	"./Bed_Portuguese_Cama.mp3": 41724,
	"./Bed_Spanish_Cama.mp3": 76653,
	"./Bee_French_Abeille.mp3": 28742,
	"./Bee_German_Biene.mp3": 60055,
	"./Bee_Italian_Ape.mp3": 49824,
	"./Bee_Polish_Pszczoła.mp3": 13299,
	"./Bee_Portuguese_Abelha.mp3": 77348,
	"./Bee_Spanish_Abeja.mp3": 28865,
	"./Belt_French_Ceinture.mp3": 59514,
	"./Belt_German_Gürtel.mp3": 90003,
	"./Belt_Italian_Cintura.mp3": 37015,
	"./Belt_Polish_Pasek.mp3": 78656,
	"./Belt_Portuguese_Cinto.mp3": 84465,
	"./Belt_Spanish_Cinturón.mp3": 36097,
	"./Bench_French_Banc.mp3": 10106,
	"./Bench_German_Bank.mp3": 20276,
	"./Bench_Italian_Panca.mp3": 15063,
	"./Bench_Polish_Ławka.mp3": 29886,
	"./Bench_Portuguese_Banco.mp3": 59758,
	"./Bench_Spanish_Banco.mp3": 55059,
	"./Bicycle_French_Vélo.mp3": 67529,
	"./Bicycle_German_Fahrrad.mp3": 1403,
	"./Bicycle_Italian_Bicicletta.mp3": 16397,
	"./Bicycle_Polish_Rower.mp3": 99657,
	"./Bicycle_Portuguese_Bicicleta.mp3": 76262,
	"./Bicycle_Spanish_Bicicleta.mp3": 82977,
	"./Bird_French_Oiseau.mp3": 96125,
	"./Bird_German_Vogel.mp3": 90160,
	"./Bird_Italian_Uccello.mp3": 57790,
	"./Bird_Polish_Ptak.mp3": 62810,
	"./Bird_Portuguese_Pássaro.mp3": 60887,
	"./Bird_Spanish_Pájaro.mp3": 41676,
	"./Boat_French_Bateau.mp3": 20740,
	"./Boat_German_Boot.mp3": 88522,
	"./Boat_Italian_Barca.mp3": 95582,
	"./Boat_Polish_Łódka.mp3": 38683,
	"./Boat_Portuguese_Barco.mp3": 7610,
	"./Boat_Spanish_Barco.mp3": 3151,
	"./Bone_French_Os.mp3": 15174,
	"./Bone_German_Knochen.mp3": 91604,
	"./Bone_Italian_Osso.mp3": 28030,
	"./Bone_Polish_Kość.mp3": 15801,
	"./Bone_Portuguese_Osso.mp3": 29177,
	"./Bone_Spanish_Hueso.mp3": 24910,
	"./Book_French_Livre.mp3": 88281,
	"./Book_German_Buch.mp3": 48149,
	"./Book_Italian_Libro.mp3": 81263,
	"./Book_Polish_Książka.mp3": 21444,
	"./Book_Portuguese_Livro.mp3": 85144,
	"./Book_Spanish_Libro.mp3": 75759,
	"./Bottle_French_Bouteille.mp3": 55207,
	"./Bottle_German_Flasche.mp3": 67216,
	"./Bottle_Italian_Bottiglia.mp3": 43017,
	"./Bottle_Polish_Butelka.mp3": 8375,
	"./Bottle_Portuguese_Garrafa.mp3": 28891,
	"./Bottle_Spanish_Botella.mp3": 16845,
	"./Bowl_French_Bol.mp3": 82717,
	"./Bowl_German_Schüssel.mp3": 66271,
	"./Bowl_Italian_Ciotola.mp3": 64621,
	"./Bowl_Polish_Miska.mp3": 64120,
	"./Bowl_Portuguese_Tigela.mp3": 33007,
	"./Bowl_Spanish_Bol.mp3": 35523,
	"./Box_French_Boîte.mp3": 37375,
	"./Box_German_Schachtel.mp3": 80800,
	"./Box_Italian_Scatola.mp3": 69414,
	"./Box_Polish_Pudełko.mp3": 68736,
	"./Box_Portuguese_Caixa.mp3": 1400,
	"./Box_Spanish_Caja.mp3": 89194,
	"./Bracelet_French_Bracelet.mp3": 75954,
	"./Bracelet_German_Armband.mp3": 52355,
	"./Bracelet_Italian_Braccialetto.mp3": 28027,
	"./Bracelet_Polish_Bransoletka.mp3": 49059,
	"./Bracelet_Portuguese_Pulseira.mp3": 17088,
	"./Bracelet_Spanish_Pulsera.mp3": 23588,
	"./Brain_French_Cerveau.mp3": 83905,
	"./Brain_German_Gehirn.mp3": 19381,
	"./Brain_Italian_Cervello.mp3": 752,
	"./Brain_Polish_Mózg.mp3": 53434,
	"./Brain_Portuguese_Cérebro.mp3": 81967,
	"./Brain_Spanish_Cerebro.mp3": 60918,
	"./Bread_French_Pain.mp3": 69880,
	"./Bread_German_Brot.mp3": 65539,
	"./Bread_Italian_Pane.mp3": 13376,
	"./Bread_Polish_Chleb.mp3": 58029,
	"./Bread_Portuguese_Pão.mp3": 76909,
	"./Bread_Spanish_Pan.mp3": 2283,
	"./Broom_French_Balai.mp3": 72048,
	"./Broom_German_Besen.mp3": 53354,
	"./Broom_Italian_Scopa.mp3": 59975,
	"./Broom_Polish_Miotła.mp3": 80544,
	"./Broom_Portuguese_Vassoura.mp3": 65618,
	"./Broom_Spanish_Escoba.mp3": 33176,
	"./Bucket_French_Seau.mp3": 93722,
	"./Bucket_German_Eimer.mp3": 88296,
	"./Bucket_Italian_Secchio.mp3": 94280,
	"./Bucket_Polish_Wiaderko.mp3": 30009,
	"./Bucket_Portuguese_Balde.mp3": 90311,
	"./Bucket_Spanish_Balde.mp3": 10170,
	"./Cake_French_Gâteau.mp3": 39094,
	"./Cake_German_Kuchen.mp3": 81628,
	"./Cake_Italian_Torta.mp3": 1618,
	"./Cake_Polish_Ciasto.mp3": 23796,
	"./Cake_Portuguese_Bolo.mp3": 84321,
	"./Cake_Spanish_Pastel.mp3": 2527,
	"./Candy_French_Bonbon.mp3": 95203,
	"./Candy_German_Süßigkeit.mp3": 45086,
	"./Candy_Italian_Caramella.mp3": 77241,
	"./Candy_Polish_Cukierek.mp3": 70785,
	"./Candy_Portuguese_Bala.mp3": 87402,
	"./Candy_Spanish_Dulce.mp3": 67280,
	"./Car_French_Voiture.mp3": 65464,
	"./Car_German_Auto.mp3": 14555,
	"./Car_Italian_Auto.mp3": 93951,
	"./Car_Polish_Samochód.mp3": 53365,
	"./Car_Portuguese_Carro.mp3": 72388,
	"./Car_Spanish_Coche.mp3": 61886,
	"./Carrot_French_Carotte.mp3": 1759,
	"./Carrot_German_Karotte.mp3": 25773,
	"./Carrot_Italian_Carota.mp3": 24043,
	"./Carrot_Polish_Marchewka.mp3": 50715,
	"./Carrot_Portuguese_Cenoura.mp3": 73571,
	"./Carrot_Spanish_Zanahoria.mp3": 86832,
	"./Castle_French_Château.mp3": 47356,
	"./Castle_German_Schloss.mp3": 20375,
	"./Castle_Italian_Castello.mp3": 10313,
	"./Castle_Polish_Zamek.mp3": 51345,
	"./Castle_Portuguese_Castelo.mp3": 90924,
	"./Castle_Spanish_Castillo.mp3": 88869,
	"./Cat_French_Chat.mp3": 87216,
	"./Cat_German_Katze.mp3": 95175,
	"./Cat_Italian_Gatto.mp3": 2563,
	"./Cat_Polish_Kot.mp3": 66987,
	"./Cat_Portuguese_Gato.mp3": 50672,
	"./Cat_Spanish_Gato.mp3": 8735,
	"./Chair_French_Chaise.mp3": 30998,
	"./Chair_German_Stuhl.mp3": 19676,
	"./Chair_Italian_Sedia.mp3": 39337,
	"./Chair_Polish_Krzesło.mp3": 85298,
	"./Chair_Portuguese_Cadeira.mp3": 41581,
	"./Chair_Spanish_Silla.mp3": 95478,
	"./Cheese_French_Fromage.mp3": 64662,
	"./Cheese_German_Käse.mp3": 94022,
	"./Cheese_Italian_Formaggio.mp3": 46262,
	"./Cheese_Polish_Ser.mp3": 1374,
	"./Cheese_Portuguese_Queijo.mp3": 85909,
	"./Cheese_Spanish_Queso.mp3": 4782,
	"./Cherry_French_Cerise.mp3": 20906,
	"./Cherry_German_Kirsche.mp3": 85024,
	"./Cherry_Italian_Ciliegia.mp3": 95738,
	"./Cherry_Polish_Wiśnia.mp3": 14373,
	"./Cherry_Portuguese_Cereja.mp3": 12944,
	"./Cherry_Spanish_Cereza.mp3": 66485,
	"./Chicken_French_Poulet.mp3": 14244,
	"./Chicken_German_Hähnchen.mp3": 14927,
	"./Chicken_Italian_Pollo.mp3": 80143,
	"./Chicken_Polish_Kurczak.mp3": 40335,
	"./Chicken_Portuguese_Frango.mp3": 49665,
	"./Chicken_Spanish_Pollo.mp3": 44999,
	"./Chocolate_French_Chocolat.mp3": 87513,
	"./Chocolate_German_Schokolade.mp3": 33745,
	"./Chocolate_Italian_Cioccolato.mp3": 86048,
	"./Chocolate_Polish_Czekolada.mp3": 25193,
	"./Chocolate_Portuguese_Chocolate.mp3": 2249,
	"./Chocolate_Spanish_Chocolate.mp3": 43224,
	"./Clock_French_Horloge.mp3": 69084,
	"./Clock_German_Uhr.mp3": 80689,
	"./Clock_Italian_Orologio.mp3": 49842,
	"./Clock_Polish_Zegar.mp3": 46072,
	"./Clock_Portuguese_Relógio.mp3": 33328,
	"./Clock_Spanish_Reloj.mp3": 89516,
	"./Coffee_French_Café.mp3": 97201,
	"./Coffee_German_Kaffee.mp3": 17634,
	"./Coffee_Italian_Caffè.mp3": 5464,
	"./Coffee_Polish_Kawa.mp3": 19915,
	"./Coffee_Portuguese_Café.mp3": 80787,
	"./Coffee_Spanish_Café.mp3": 63347,
	"./Coin_French_Pièce de monnaie.mp3": 63974,
	"./Coin_German_Münze.mp3": 93965,
	"./Coin_Italian_Moneta.mp3": 89331,
	"./Coin_Polish_Moneta.mp3": 19402,
	"./Coin_Portuguese_Moeda.mp3": 50972,
	"./Coin_Spanish_Moneda.mp3": 70323,
	"./Cold_French_Froid.mp3": 2436,
	"./Cold_German_Kalt.mp3": 83382,
	"./Cold_Italian_Freddo.mp3": 35194,
	"./Cold_Polish_Zimny.mp3": 47824,
	"./Cold_Portuguese_Frio.mp3": 11789,
	"./Cold_Spanish_Frío.mp3": 30770,
	"./Cookie_French_Biscuit.mp3": 75553,
	"./Cookie_German_Plätzchen.mp3": 66795,
	"./Cookie_Italian_Biscotto.mp3": 82957,
	"./Cookie_Polish_Ciastko.mp3": 87429,
	"./Cookie_Portuguese_Biscoito.mp3": 12111,
	"./Cookie_Spanish_Galleta.mp3": 6334,
	"./Couch_French_Canapé.mp3": 24394,
	"./Couch_German_Couch.mp3": 72144,
	"./Couch_Italian_Divano.mp3": 48345,
	"./Couch_Polish_Kanapa.mp3": 45059,
	"./Couch_Portuguese_Sofá.mp3": 97880,
	"./Couch_Spanish_Sofá.mp3": 53079,
	"./Cow_French_Vache.mp3": 13050,
	"./Cow_German_Kuh.mp3": 42883,
	"./Cow_Italian_Mucca.mp3": 18408,
	"./Cow_Polish_Krowa.mp3": 76704,
	"./Cow_Portuguese_Vaca.mp3": 31637,
	"./Cow_Spanish_Vaca.mp3": 79604,
	"./Doctor_French_Médecin.mp3": 97990,
	"./Doctor_German_Arzt.mp3": 7666,
	"./Doctor_Italian_Medico.mp3": 20302,
	"./Doctor_Polish_Lekarz.mp3": 74035,
	"./Doctor_Portuguese_Médico.mp3": 13187,
	"./Doctor_Spanish_Médico.mp3": 55074,
	"./Dog_French_Chien.mp3": 96127,
	"./Dog_German_Hund.mp3": 54497,
	"./Dog_Italian_Cane.mp3": 36337,
	"./Dog_Polish_Pies.mp3": 76616,
	"./Dog_Portuguese_Cachorro.mp3": 71854,
	"./Dog_Spanish_Perro.mp3": 27262,
	"./Doll_French_Poupée.mp3": 89819,
	"./Doll_German_Puppe.mp3": 61747,
	"./Doll_Italian_Bambola.mp3": 73503,
	"./Doll_Polish_Lalka.mp3": 78847,
	"./Doll_Portuguese_Boneca.mp3": 91054,
	"./Doll_Spanish_Muñeca.mp3": 30781,
	"./Door_French_Porte.mp3": 66720,
	"./Door_German_Tür.mp3": 79802,
	"./Door_Italian_Porta.mp3": 80906,
	"./Door_Polish_Drzwi.mp3": 51161,
	"./Door_Portuguese_Porta.mp3": 73507,
	"./Door_Spanish_Puerta.mp3": 66053,
	"./Dress_French_Robe.mp3": 80765,
	"./Dress_German_Kleid.mp3": 40134,
	"./Dress_Italian_Vestito.mp3": 65429,
	"./Dress_Polish_Sukienka.mp3": 43611,
	"./Dress_Portuguese_Vestido.mp3": 72454,
	"./Dress_Spanish_Vestido.mp3": 76941,
	"./Duck_French_Canard.mp3": 84700,
	"./Duck_German_Ente.mp3": 65623,
	"./Duck_Italian_Anatra.mp3": 24860,
	"./Duck_Polish_Kaczka.mp3": 64239,
	"./Duck_Portuguese_Pato.mp3": 20570,
	"./Duck_Spanish_Pato.mp3": 79439,
	"./Earring_French_Boucle d'oreille.mp3": 57767,
	"./Earring_German_Ohrring.mp3": 7361,
	"./Earring_Italian_Orecchino.mp3": 53804,
	"./Earring_Polish_Kolczyk.mp3": 56346,
	"./Earring_Portuguese_Brinco.mp3": 84674,
	"./Earring_Spanish_Arete.mp3": 24089,
	"./Egg_French_Œuf.mp3": 27408,
	"./Egg_German_Ei.mp3": 30277,
	"./Egg_Italian_Uovo.mp3": 94840,
	"./Egg_Polish_Jajko.mp3": 37929,
	"./Egg_Portuguese_Ovo.mp3": 7602,
	"./Egg_Spanish_Huevo.mp3": 18612,
	"./Eight_French_Huit.mp3": 71053,
	"./Eight_German_Acht.mp3": 36033,
	"./Eight_Italian_Otto.mp3": 89469,
	"./Eight_Polish_Osiem.mp3": 49563,
	"./Eight_Portuguese_Oito.mp3": 34713,
	"./Eight_Spanish_Ocho.mp3": 40578,
	"./Eye_French_Œil.mp3": 72422,
	"./Eye_German_Auge.mp3": 67941,
	"./Eye_Italian_Occhio.mp3": 16526,
	"./Eye_Polish_Oko.mp3": 5169,
	"./Eye_Portuguese_Olho.mp3": 42170,
	"./Eye_Spanish_Ojo.mp3": 97213,
	"./Face_French_Visage.mp3": 24766,
	"./Face_German_Gesicht.mp3": 75622,
	"./Face_Italian_Viso.mp3": 65508,
	"./Face_Polish_Twarz.mp3": 64888,
	"./Face_Portuguese_Rosto.mp3": 73207,
	"./Face_Spanish_Rostro.mp3": 22092,
	"./Farm_French_Ferme.mp3": 75943,
	"./Farm_German_Bauernhof.mp3": 29664,
	"./Farm_Italian_Fattoria.mp3": 9022,
	"./Farm_Polish_Farma.mp3": 24308,
	"./Farm_Portuguese_Fazenda.mp3": 1462,
	"./Farm_Spanish_Granja.mp3": 75453,
	"./Finger_French_Doigt.mp3": 23442,
	"./Finger_German_Finger.mp3": 15368,
	"./Finger_Italian_Dito.mp3": 94299,
	"./Finger_Polish_Palec.mp3": 70019,
	"./Finger_Portuguese_Dedo.mp3": 52738,
	"./Finger_Spanish_Dedo.mp3": 33239,
	"./Fire_French_Feu.mp3": 81338,
	"./Fire_German_Feuer.mp3": 70221,
	"./Fire_Italian_Fuoco.mp3": 43324,
	"./Fire_Polish_Ogień.mp3": 73453,
	"./Fire_Portuguese_Fogo.mp3": 95668,
	"./Fire_Spanish_Fuego.mp3": 53150,
	"./Fish_French_Poisson.mp3": 12705,
	"./Fish_German_Fisch.mp3": 44885,
	"./Fish_Italian_Pescare.mp3": 82401,
	"./Fish_Polish_Ryba.mp3": 18309,
	"./Fish_Portuguese_Peixe.mp3": 66252,
	"./Fish_Spanish_Pez.mp3": 88919,
	"./Five_French_Cinq.mp3": 74309,
	"./Five_German_Fünf.mp3": 77994,
	"./Five_Italian_Cinque.mp3": 98829,
	"./Five_Polish_Pięć.mp3": 43838,
	"./Five_Portuguese_Cinco.mp3": 90593,
	"./Five_Spanish_Cinco.mp3": 98676,
	"./Flour_French_Farine.mp3": 35489,
	"./Flour_German_Mehl.mp3": 69394,
	"./Flour_Italian_Farina.mp3": 17771,
	"./Flour_Polish_Mąka.mp3": 23157,
	"./Flour_Portuguese_Farinha.mp3": 26878,
	"./Flour_Spanish_Harina.mp3": 84097,
	"./Flower_French_Fleur.mp3": 3600,
	"./Flower_German_Blume.mp3": 62562,
	"./Flower_Italian_Fiore.mp3": 54772,
	"./Flower_Polish_Kwiat.mp3": 98502,
	"./Flower_Portuguese_Flor.mp3": 6615,
	"./Flower_Spanish_Flor.mp3": 73766,
	"./Fork_French_Fourchette.mp3": 41209,
	"./Fork_German_Gabel.mp3": 70601,
	"./Fork_Italian_Forchetta.mp3": 33086,
	"./Fork_Polish_Widelec.mp3": 46154,
	"./Fork_Portuguese_Garfo.mp3": 84450,
	"./Fork_Spanish_Tenedor.mp3": 25089,
	"./Four_French_Quatre.mp3": 1648,
	"./Four_German_Vier.mp3": 32962,
	"./Four_Italian_Quattro.mp3": 61626,
	"./Four_Polish_Cztery.mp3": 14286,
	"./Four_Portuguese_Quatro.mp3": 98635,
	"./Four_Spanish_Cuatro.mp3": 8802,
	"./Fruit_French_Fruit.mp3": 17850,
	"./Fruit_German_Obst.mp3": 88732,
	"./Fruit_Italian_Frutta.mp3": 70516,
	"./Fruit_Polish_Owoc.mp3": 88633,
	"./Fruit_Portuguese_Fruta.mp3": 49127,
	"./Fruit_Spanish_Fruta.mp3": 1266,
	"./Garlic_French_Ail.mp3": 54522,
	"./Garlic_German_Knoblauch.mp3": 38237,
	"./Garlic_Italian_Aglio.mp3": 3234,
	"./Garlic_Polish_Czosnek.mp3": 93318,
	"./Garlic_Portuguese_Alho.mp3": 3137,
	"./Garlic_Spanish_Ajo.mp3": 51690,
	"./Glass_French_Verre.mp3": 51938,
	"./Glass_German_Glas.mp3": 49909,
	"./Glass_Italian_Bicchiere.mp3": 26222,
	"./Glass_Polish_Szklanka.mp3": 18760,
	"./Glass_Portuguese_Copo.mp3": 20553,
	"./Glass_Spanish_Vaso.mp3": 79409,
	"./Glove_French_Gant.mp3": 26667,
	"./Glove_German_Handschuh.mp3": 15357,
	"./Glove_Italian_Guanto.mp3": 4215,
	"./Glove_Polish_Rękawica.mp3": 879,
	"./Glove_Portuguese_Luva.mp3": 52430,
	"./Glove_Spanish_Guante.mp3": 21997,
	"./Grape_French_Raisin.mp3": 43813,
	"./Grape_German_Traube.mp3": 96842,
	"./Grape_Italian_Uva.mp3": 35991,
	"./Grape_Polish_Winogrono.mp3": 61002,
	"./Grape_Portuguese_Uva.mp3": 22696,
	"./Grape_Spanish_Uva.mp3": 51663,
	"./Green_French_Vert.mp3": 93710,
	"./Green_German_Grün.mp3": 96984,
	"./Green_Italian_Verde.mp3": 61147,
	"./Green_Polish_Zielony.mp3": 99006,
	"./Green_Portuguese_Verde.mp3": 13880,
	"./Green_Spanish_Verde.mp3": 78067,
	"./Hand_French_Main.mp3": 88566,
	"./Hand_German_Hand.mp3": 80252,
	"./Hand_Italian_Mano.mp3": 25282,
	"./Hand_Polish_Ręka.mp3": 53315,
	"./Hand_Portuguese_Mão.mp3": 41028,
	"./Hand_Spanish_Mano.mp3": 16386,
	"./Hat_French_Chapeau.mp3": 90254,
	"./Hat_German_Hut.mp3": 78874,
	"./Hat_Italian_Cappello.mp3": 44117,
	"./Hat_Polish_Kapelusz.mp3": 41387,
	"./Hat_Portuguese_Chapéu.mp3": 25336,
	"./Hat_Spanish_Sombrero.mp3": 47376,
	"./Head_French_Tête.mp3": 74815,
	"./Head_German_Kopf.mp3": 70542,
	"./Head_Italian_Testa.mp3": 56783,
	"./Head_Polish_Głowa.mp3": 25137,
	"./Head_Portuguese_Cabeça.mp3": 99978,
	"./Head_Spanish_Cabeza.mp3": 37858,
	"./Health_French_Santé.mp3": 86255,
	"./Health_German_Gesundheit.mp3": 68906,
	"./Health_Italian_Salute.mp3": 13630,
	"./Health_Polish_Zdrowie.mp3": 60535,
	"./Health_Portuguese_Saúde.mp3": 64800,
	"./Health_Spanish_Salud.mp3": 73581,
	"./Heart_French_Cœur.mp3": 88693,
	"./Heart_German_Herz.mp3": 73053,
	"./Heart_Italian_Cuore.mp3": 2008,
	"./Heart_Polish_Serce.mp3": 27055,
	"./Heart_Portuguese_Coração.mp3": 80707,
	"./Heart_Spanish_Corazón.mp3": 77106,
	"./Heavy_French_Lourd.mp3": 40799,
	"./Heavy_German_Schwer.mp3": 37053,
	"./Heavy_Italian_Pesante.mp3": 26933,
	"./Heavy_Polish_Ciężki.mp3": 54317,
	"./Heavy_Portuguese_Pesado.mp3": 41032,
	"./Heavy_Spanish_Pesado.mp3": 35525,
	"./Help_French_Aide.mp3": 23620,
	"./Help_German_Helfen.mp3": 14139,
	"./Help_Italian_Aiuto.mp3": 79565,
	"./Help_Polish_Pomoc.mp3": 56376,
	"./Help_Portuguese_Ajuda.mp3": 7029,
	"./Help_Spanish_Ayuda.mp3": 71656,
	"./History_French_Histoire.mp3": 62217,
	"./History_German_Geschichte.mp3": 67019,
	"./History_Italian_Storia.mp3": 16084,
	"./History_Polish_Historia.mp3": 51046,
	"./History_Portuguese_História.mp3": 81202,
	"./History_Spanish_Historia.mp3": 82845,
	"./Hook_French_Crochet.mp3": 93005,
	"./Hook_German_Haken.mp3": 22570,
	"./Hook_Italian_Gancio.mp3": 56638,
	"./Hook_Polish_Hak.mp3": 42582,
	"./Hook_Portuguese_Gancho.mp3": 36788,
	"./Hook_Spanish_Gancho.mp3": 5197,
	"./Horse_French_Cheval.mp3": 88030,
	"./Horse_German_Pferd.mp3": 2612,
	"./Horse_Italian_Cavallo.mp3": 70893,
	"./Horse_Polish_Koń.mp3": 94942,
	"./Horse_Portuguese_Cavalo.mp3": 67700,
	"./Horse_Spanish_Caballo.mp3": 73505,
	"./Hose_French_Tuyau.mp3": 51811,
	"./Hose_German_Schlauch.mp3": 53442,
	"./Hose_Italian_Tubo flessibile.mp3": 40123,
	"./Hose_Polish_Wąż gumowy.mp3": 91560,
	"./Hose_Portuguese_Mangueira.mp3": 12901,
	"./Hose_Spanish_Manguera.mp3": 38451,
	"./Hospital_French_Hôpital.mp3": 8676,
	"./Hospital_German_Krankenhaus.mp3": 28243,
	"./Hospital_Italian_Ospedale.mp3": 10429,
	"./Hospital_Polish_Szpital.mp3": 82230,
	"./Hospital_Portuguese_Hospital.mp3": 64927,
	"./Hospital_Spanish_Hospital.mp3": 88332,
	"./Hot_French_Chaud.mp3": 97364,
	"./Hot_German_Heiß.mp3": 64780,
	"./Hot_Italian_Caldo.mp3": 19782,
	"./Hot_Polish_Gorący.mp3": 19503,
	"./Hot_Portuguese_Quente.mp3": 44268,
	"./Hot_Spanish_Caliente.mp3": 24034,
	"./House_French_Maison.mp3": 68455,
	"./House_German_Haus.mp3": 52761,
	"./House_Italian_Casa.mp3": 99716,
	"./House_Polish_Dom.mp3": 28473,
	"./House_Portuguese_Casa.mp3": 59047,
	"./House_Spanish_Casa.mp3": 73604,
	"./Husband_French_Mari.mp3": 3746,
	"./Husband_German_Ehemann.mp3": 56437,
	"./Husband_Italian_Marito.mp3": 21301,
	"./Husband_Polish_Mąż.mp3": 57472,
	"./Husband_Portuguese_Marido.mp3": 5848,
	"./Husband_Spanish_Marido.mp3": 59821,
	"./Jug_French_Cruche.mp3": 90046,
	"./Jug_German_Krug.mp3": 14237,
	"./Jug_Italian_Brocca.mp3": 55344,
	"./Jug_Polish_Dzbanek.mp3": 1854,
	"./Jug_Portuguese_Jarro.mp3": 26621,
	"./Jug_Spanish_Jarra.mp3": 2602,
	"./Key_French_Clé.mp3": 10547,
	"./Key_German_Schlüssel.mp3": 70688,
	"./Key_Italian_Chiave.mp3": 28235,
	"./Key_Polish_Klucz.mp3": 98967,
	"./Key_Portuguese_Chave.mp3": 82479,
	"./Key_Spanish_Llave.mp3": 72723,
	"./Kite_French_Cerf-volant.mp3": 74994,
	"./Kite_German_Drachen.mp3": 51308,
	"./Kite_Italian_Aquilone.mp3": 15551,
	"./Kite_Polish_Latawiec.mp3": 56722,
	"./Kite_Portuguese_Pipa.mp3": 33070,
	"./Kite_Spanish_Cometa.mp3": 87086,
	"./Knife_French_Couteau.mp3": 87095,
	"./Knife_German_Messer.mp3": 42134,
	"./Knife_Italian_Coltello.mp3": 92267,
	"./Knife_Polish_Nóż.mp3": 4247,
	"./Knife_Portuguese_Faca.mp3": 84611,
	"./Knife_Spanish_Cuchillo.mp3": 11280,
	"./Large_French_Grand.mp3": 88319,
	"./Large_German_Groß.mp3": 22040,
	"./Large_Italian_Grande.mp3": 39060,
	"./Large_Polish_Duży.mp3": 26210,
	"./Large_Portuguese_Grande.mp3": 5341,
	"./Large_Spanish_Grande.mp3": 6716,
	"./Left_French_Gauche.mp3": 30312,
	"./Left_German_Links.mp3": 19222,
	"./Left_Italian_Sinistra.mp3": 11084,
	"./Left_Polish_Lewy.mp3": 55701,
	"./Left_Portuguese_Esquerda.mp3": 65742,
	"./Left_Spanish_Izquierda.mp3": 83163,
	"./Leg_French_Jambe.mp3": 48941,
	"./Leg_German_Bein.mp3": 17010,
	"./Leg_Italian_Gamba.mp3": 14958,
	"./Leg_Polish_Noga.mp3": 77818,
	"./Leg_Portuguese_Perna.mp3": 26063,
	"./Leg_Spanish_Pierna.mp3": 91395,
	"./Lemon_French_Citron.mp3": 11886,
	"./Lemon_German_Zitrone.mp3": 94076,
	"./Lemon_Italian_Limone.mp3": 34861,
	"./Lemon_Polish_Cytryna.mp3": 21502,
	"./Lemon_Portuguese_Limão.mp3": 20554,
	"./Lemon_Spanish_Limón.mp3": 46776,
	"./Lentil_French_Lentille.mp3": 98399,
	"./Lentil_German_Linse.mp3": 65533,
	"./Lentil_Italian_Lenticchia.mp3": 56052,
	"./Lentil_Polish_Soczewica.mp3": 64907,
	"./Lentil_Portuguese_Lentilha.mp3": 50722,
	"./Lentil_Spanish_Lenteja.mp3": 5699,
	"./Lion_French_Lion.mp3": 61914,
	"./Lion_German_Löwe.mp3": 17144,
	"./Lion_Italian_Leone.mp3": 23049,
	"./Lion_Polish_Lew.mp3": 76823,
	"./Lion_Portuguese_Leão.mp3": 44042,
	"./Lion_Spanish_León.mp3": 82852,
	"./Long_French_Long.mp3": 93402,
	"./Long_German_Lang.mp3": 14770,
	"./Long_Italian_Lungo.mp3": 13845,
	"./Long_Polish_Długi.mp3": 63284,
	"./Long_Portuguese_Longo.mp3": 40762,
	"./Long_Spanish_Largo.mp3": 23477,
	"./Luggage_French_Bagage.mp3": 18777,
	"./Luggage_German_Gepäck.mp3": 45182,
	"./Luggage_Italian_Bagaglio.mp3": 97106,
	"./Luggage_Polish_Bagaż.mp3": 13556,
	"./Luggage_Portuguese_Bagagem.mp3": 89369,
	"./Luggage_Spanish_Equipaje.mp3": 31370,
	"./Man_French_Homme.mp3": 66220,
	"./Man_German_Mann.mp3": 11542,
	"./Man_Italian_Uomo.mp3": 40556,
	"./Man_Polish_Człowiek.mp3": 32965,
	"./Man_Portuguese_Homem.mp3": 54379,
	"./Man_Spanish_Hombre.mp3": 24825,
	"./Mattress_French_Matelas.mp3": 82522,
	"./Mattress_German_Matratze.mp3": 99287,
	"./Mattress_Italian_Materasso.mp3": 21793,
	"./Mattress_Polish_Materac.mp3": 89483,
	"./Mattress_Portuguese_Colchão.mp3": 68641,
	"./Mattress_Spanish_Colchón.mp3": 38215,
	"./Milk_French_Lait.mp3": 37949,
	"./Milk_German_Milch.mp3": 95072,
	"./Milk_Italian_Latte.mp3": 34759,
	"./Milk_Polish_Mleko.mp3": 57216,
	"./Milk_Portuguese_Leite.mp3": 22793,
	"./Milk_Spanish_Leche.mp3": 9108,
	"./Mirror_French_Miroir.mp3": 52713,
	"./Mirror_German_Spiegel.mp3": 90358,
	"./Mirror_Italian_Specchio.mp3": 92223,
	"./Mirror_Polish_Lustro.mp3": 19919,
	"./Mirror_Portuguese_Espelho.mp3": 42266,
	"./Mirror_Spanish_Espejo.mp3": 24075,
	"./Money_French_Argent.mp3": 59733,
	"./Money_German_Geld.mp3": 14268,
	"./Money_Italian_Soldi.mp3": 92683,
	"./Money_Polish_Pieniądze.mp3": 49016,
	"./Money_Portuguese_Dinheiro.mp3": 81391,
	"./Money_Spanish_Dinero.mp3": 89847,
	"./Monkey_French_Singe.mp3": 65257,
	"./Monkey_German_Affe.mp3": 85957,
	"./Monkey_Italian_Scimmia.mp3": 11580,
	"./Monkey_Polish_Małpa.mp3": 73593,
	"./Monkey_Portuguese_Macaco.mp3": 9088,
	"./Monkey_Spanish_Mono.mp3": 99660,
	"./Month_French_Mois.mp3": 63616,
	"./Month_German_Monat.mp3": 2267,
	"./Month_Italian_Mese.mp3": 46736,
	"./Month_Polish_Miesiąc.mp3": 41128,
	"./Month_Portuguese_Mês.mp3": 60143,
	"./Month_Spanish_Mes.mp3": 11739,
	"./Morning_French_Matin.mp3": 17833,
	"./Morning_German_Morgen.mp3": 95108,
	"./Morning_Italian_Mattina.mp3": 60324,
	"./Morning_Polish_Rano.mp3": 25925,
	"./Morning_Portuguese_Manhã.mp3": 62982,
	"./Morning_Spanish_Mañana.mp3": 25207,
	"./Mouse_French_Souris.mp3": 18052,
	"./Mouse_German_Maus.mp3": 13495,
	"./Mouse_Italian_Topo.mp3": 8527,
	"./Mouse_Polish_Mysz.mp3": 18311,
	"./Mouse_Portuguese_Rato.mp3": 96970,
	"./Mouse_Spanish_Ratón.mp3": 95011,
	"./Mouth_French_Bouche.mp3": 29499,
	"./Mouth_German_Mund.mp3": 49565,
	"./Mouth_Italian_Bocca.mp3": 31177,
	"./Mouth_Polish_Usta.mp3": 29739,
	"./Mouth_Portuguese_Boca.mp3": 1247,
	"./Mouth_Spanish_Boca.mp3": 38494,
	"./Mushroom_French_Champignon.mp3": 81098,
	"./Mushroom_German_Pilz.mp3": 11025,
	"./Mushroom_Italian_Fungo.mp3": 2171,
	"./Mushroom_Polish_Grzyb.mp3": 30681,
	"./Mushroom_Portuguese_Cogumelo.mp3": 5910,
	"./Mushroom_Spanish_Champiñón.mp3": 19778,
	"./Name_French_Nom.mp3": 87563,
	"./Name_German_Name.mp3": 81284,
	"./Name_Italian_Nome.mp3": 67992,
	"./Name_Polish_Nazwa.mp3": 95937,
	"./Name_Portuguese_Nome.mp3": 71773,
	"./Name_Spanish_Nombre.mp3": 20704,
	"./Nest_French_Nid.mp3": 95005,
	"./Nest_German_Nest.mp3": 25656,
	"./Nest_Italian_Nido.mp3": 80686,
	"./Nest_Polish_Gniazdo.mp3": 53925,
	"./Nest_Portuguese_Ninho.mp3": 4843,
	"./Nest_Spanish_Nido.mp3": 53966,
	"./Nine_French_Neuf.mp3": 59036,
	"./Nine_German_Neun.mp3": 76630,
	"./Nine_Italian_Nove.mp3": 15718,
	"./Nine_Polish_Dziewięć.mp3": 91323,
	"./Nine_Portuguese_Nove.mp3": 16117,
	"./Nine_Spanish_Nueve.mp3": 98523,
	"./North_French_Nord.mp3": 81476,
	"./North_German_Norden.mp3": 95375,
	"./North_Italian_Nord.mp3": 83916,
	"./North_Polish_Północ.mp3": 1655,
	"./North_Portuguese_Norte.mp3": 22325,
	"./North_Spanish_Norte.mp3": 83293,
	"./Nose_French_Nez.mp3": 8174,
	"./Nose_German_Nase.mp3": 38226,
	"./Nose_Italian_Naso.mp3": 50574,
	"./Nose_Polish_Nos.mp3": 1798,
	"./Nose_Portuguese_Nariz.mp3": 13272,
	"./Nose_Spanish_Nariz.mp3": 13867,
	"./Oat_French_Avoine.mp3": 30772,
	"./Oat_German_Hafer.mp3": 19148,
	"./Oat_Italian_Avena.mp3": 94605,
	"./Oat_Polish_Owies.mp3": 81274,
	"./Oat_Portuguese_Aveia.mp3": 27058,
	"./Oat_Spanish_Avena.mp3": 40653,
	"./Office_French_Bureau.mp3": 16160,
	"./Office_German_Büro.mp3": 97951,
	"./Office_Italian_Ufficio.mp3": 55933,
	"./Office_Polish_Biuro.mp3": 67092,
	"./Office_Portuguese_Escritório.mp3": 89392,
	"./Office_Spanish_Oficina.mp3": 42687,
	"./Oil_French_Huile.mp3": 40533,
	"./Oil_German_Öl.mp3": 40046,
	"./Oil_Italian_Olio.mp3": 90613,
	"./Oil_Polish_Olej.mp3": 39263,
	"./Oil_Portuguese_Óleo.mp3": 65850,
	"./Oil_Spanish_Aceite.mp3": 90107,
	"./One_French_Un.mp3": 40187,
	"./One_German_Eins.mp3": 58279,
	"./One_Italian_Uno.mp3": 52528,
	"./One_Polish_Jeden.mp3": 39037,
	"./One_Portuguese_Um.mp3": 80533,
	"./One_Spanish_Uno.mp3": 17424,
	"./Onion_French_Oignon.mp3": 8133,
	"./Onion_German_Zwiebel.mp3": 37501,
	"./Onion_Italian_Cipolla.mp3": 62111,
	"./Onion_Polish_Cebula.mp3": 16206,
	"./Onion_Portuguese_Cebola.mp3": 74984,
	"./Onion_Spanish_Cebolla.mp3": 28109,
	"./Oven_French_Four.mp3": 25719,
	"./Oven_German_Ofen.mp3": 53476,
	"./Oven_Italian_Forno.mp3": 85158,
	"./Oven_Polish_Piekarnik.mp3": 89409,
	"./Oven_Portuguese_Forno.mp3": 36579,
	"./Oven_Spanish_Horno.mp3": 34956,
	"./Owl_French_Hibou.mp3": 43509,
	"./Owl_German_Eule.mp3": 92397,
	"./Owl_Italian_Gufo.mp3": 59967,
	"./Owl_Polish_Sowa.mp3": 42867,
	"./Owl_Portuguese_Coruja.mp3": 53499,
	"./Owl_Spanish_Búho.mp3": 56661,
	"./Oxygen_French_Oxygène.mp3": 41866,
	"./Oxygen_German_Sauerstoff.mp3": 51992,
	"./Oxygen_Italian_Ossigeno.mp3": 48127,
	"./Oxygen_Polish_Tlen.mp3": 51318,
	"./Oxygen_Portuguese_Oxigênio.mp3": 87646,
	"./Oxygen_Spanish_Oxígeno.mp3": 11391,
	"./Pants_French_Pantalon.mp3": 11683,
	"./Pants_German_Hose.mp3": 60713,
	"./Pants_Italian_Pantaloni.mp3": 56142,
	"./Pants_Polish_Spodnie.mp3": 71467,
	"./Pants_Portuguese_Calças.mp3": 89094,
	"./Pants_Spanish_Pantalones.mp3": 75225,
	"./Pear_French_Poire.mp3": 74693,
	"./Pear_German_Birne.mp3": 96380,
	"./Pear_Italian_Pera.mp3": 90814,
	"./Pear_Polish_Gruszka.mp3": 91174,
	"./Pear_Portuguese_Pera.mp3": 54441,
	"./Pear_Spanish_Pera.mp3": 58478,
	"./Pen_French_Stylo.mp3": 48904,
	"./Pen_German_Stift.mp3": 79871,
	"./Pen_Italian_Penna.mp3": 63975,
	"./Pen_Polish_Długopis.mp3": 68009,
	"./Pen_Portuguese_Caneta.mp3": 32600,
	"./Pen_Spanish_Bolígrafo.mp3": 78072,
	"./Pencil_French_Crayon.mp3": 61975,
	"./Pencil_German_Bleistift.mp3": 78009,
	"./Pencil_Italian_Matita.mp3": 71115,
	"./Pencil_Polish_Ołówek.mp3": 25697,
	"./Pencil_Portuguese_Lápis.mp3": 83471,
	"./Pencil_Spanish_Lápiz.mp3": 45213,
	"./Pepper_French_Poivre.mp3": 33467,
	"./Pepper_German_Pfeffer.mp3": 36078,
	"./Pepper_Italian_Pepe.mp3": 17060,
	"./Pepper_Polish_Pieprz.mp3": 45429,
	"./Pepper_Portuguese_Pimenta.mp3": 23443,
	"./Pepper_Spanish_Pimienta.mp3": 21255,
	"./Pig_French_Cochon.mp3": 5570,
	"./Pig_German_Schwein.mp3": 83771,
	"./Pig_Italian_Maiale.mp3": 15353,
	"./Pig_Polish_Świnia.mp3": 47641,
	"./Pig_Portuguese_Porco.mp3": 12708,
	"./Pig_Spanish_Cerdo.mp3": 41829,
	"./Pink_French_Rose.mp3": 59847,
	"./Pink_German_Rosa.mp3": 39457,
	"./Pink_Italian_Rosa.mp3": 52969,
	"./Pink_Polish_Różowy.mp3": 79881,
	"./Pink_Portuguese_Rosa.mp3": 13986,
	"./Pink_Spanish_Rosa.mp3": 72505,
	"./Plum_French_Prune.mp3": 74108,
	"./Plum_German_Pflaume.mp3": 17184,
	"./Plum_Italian_Prugna.mp3": 95355,
	"./Plum_Polish_Śliwka.mp3": 43911,
	"./Plum_Portuguese_Ameixa.mp3": 83720,
	"./Plum_Spanish_Ciruelo.mp3": 6513,
	"./Pool_French_Piscine.mp3": 77331,
	"./Pool_German_Schwimmbad.mp3": 58419,
	"./Pool_Italian_Piscina.mp3": 15689,
	"./Pool_Polish_Basen.mp3": 88400,
	"./Pool_Portuguese_Piscina.mp3": 25368,
	"./Pool_Spanish_Piscina.mp3": 83817,
	"./Popcorn_French_Pop-corn.mp3": 99781,
	"./Popcorn_German_Popcorn.mp3": 1646,
	"./Popcorn_Italian_Popcorn.mp3": 49204,
	"./Popcorn_Polish_Popcorn.mp3": 92707,
	"./Popcorn_Portuguese_Pipoca.mp3": 11022,
	"./Popcorn_Spanish_Palomitas.mp3": 11219,
	"./Purple_French_Violet.mp3": 37441,
	"./Purple_German_Lila.mp3": 13298,
	"./Purple_Italian_Viola.mp3": 39305,
	"./Purple_Polish_Fioletowy.mp3": 53135,
	"./Purple_Portuguese_Roxo.mp3": 41491,
	"./Purple_Spanish_Morado.mp3": 5078,
	"./Rabbit_French_Lapin.mp3": 65120,
	"./Rabbit_German_Hase.mp3": 19833,
	"./Rabbit_Italian_Coniglio.mp3": 31640,
	"./Rabbit_Polish_Królik.mp3": 91037,
	"./Rabbit_Portuguese_Coelho.mp3": 4449,
	"./Rabbit_Spanish_Conejo.mp3": 92428,
	"./Rag_French_Chiffon.mp3": 89013,
	"./Rag_German_Lappen.mp3": 77978,
	"./Rag_Italian_Straccio.mp3": 490,
	"./Rag_Polish_Szmata.mp3": 38985,
	"./Rag_Portuguese_Pano.mp3": 3921,
	"./Rag_Spanish_Trapo.mp3": 41338,
	"./Red_French_Rouge.mp3": 80383,
	"./Red_German_Rot.mp3": 58336,
	"./Red_Italian_Rosso.mp3": 23803,
	"./Red_Polish_Czerwony.mp3": 17589,
	"./Red_Portuguese_Vermelho.mp3": 82626,
	"./Red_Spanish_Rojo.mp3": 90019,
	"./Rice_French_Riz.mp3": 80912,
	"./Rice_German_Reis.mp3": 23104,
	"./Rice_Italian_Riso.mp3": 28884,
	"./Rice_Polish_Ryż.mp3": 69269,
	"./Rice_Portuguese_Arroz.mp3": 41378,
	"./Rice_Spanish_Arroz.mp3": 21941,
	"./Salt_French_Sel.mp3": 65702,
	"./Salt_German_Salz.mp3": 40326,
	"./Salt_Italian_Sale.mp3": 92413,
	"./Salt_Polish_Sól.mp3": 12619,
	"./Salt_Portuguese_Sal.mp3": 21681,
	"./Salt_Spanish_Sal.mp3": 54228,
	"./Sandal_French_Sandale.mp3": 29467,
	"./Sandal_German_Sandale.mp3": 96805,
	"./Sandal_Italian_Sandalo.mp3": 1249,
	"./Sandal_Polish_Sandał.mp3": 86729,
	"./Sandal_Portuguese_Sandália.mp3": 86105,
	"./Sandal_Spanish_Sandalia.mp3": 66248,
	"./Scissors_French_Ciseaux.mp3": 79851,
	"./Scissors_German_Schere.mp3": 2485,
	"./Scissors_Italian_Forbici.mp3": 49335,
	"./Scissors_Polish_Nożyce.mp3": 99042,
	"./Scissors_Portuguese_Tesoura.mp3": 58145,
	"./Scissors_Spanish_Tijeras.mp3": 61993,
	"./Scooter_French_Trottinette.mp3": 84079,
	"./Scooter_German_Roller.mp3": 98613,
	"./Scooter_Italian_Scooter.mp3": 29648,
	"./Scooter_Polish_Hulajnoga.mp3": 57413,
	"./Scooter_Portuguese_Patinete.mp3": 32528,
	"./Scooter_Spanish_Scooter.mp3": 53416,
	"./Seven_French_Sept.mp3": 55905,
	"./Seven_German_Sieben.mp3": 41511,
	"./Seven_Italian_Sette.mp3": 13550,
	"./Seven_Polish_Siedem.mp3": 24845,
	"./Seven_Portuguese_Sete.mp3": 93365,
	"./Seven_Spanish_Siete.mp3": 18727,
	"./Shampoo_French_Shampooing.mp3": 37692,
	"./Shampoo_German_Shampoo.mp3": 98798,
	"./Shampoo_Italian_Shampoo.mp3": 12268,
	"./Shampoo_Polish_Szampon.mp3": 49364,
	"./Shampoo_Portuguese_Xampu.mp3": 51095,
	"./Shampoo_Spanish_Champú.mp3": 39612,
	"./Sheep_French_Mouton.mp3": 21335,
	"./Sheep_German_Schaf.mp3": 42160,
	"./Sheep_Italian_Pecora.mp3": 79887,
	"./Sheep_Polish_Owce.mp3": 20332,
	"./Sheep_Portuguese_Carneiro.mp3": 41345,
	"./Sheep_Spanish_Oveja.mp3": 70717,
	"./Shirt_French_Chemise.mp3": 74730,
	"./Shirt_German_Hemd.mp3": 14642,
	"./Shirt_Italian_Camicia.mp3": 78091,
	"./Shirt_Polish_Koszula.mp3": 45810,
	"./Shirt_Portuguese_Camisa.mp3": 84369,
	"./Shirt_Spanish_Camisa.mp3": 87698,
	"./Shoe_French_Chaussure.mp3": 2196,
	"./Shoe_German_Schuh.mp3": 97558,
	"./Shoe_Italian_Scarpa.mp3": 73841,
	"./Shoe_Polish_But.mp3": 69875,
	"./Shoe_Portuguese_Sapato.mp3": 88816,
	"./Shoe_Spanish_Zapato.mp3": 77750,
	"./Short_French_Court.mp3": 58521,
	"./Short_German_Kurz.mp3": 70894,
	"./Short_Italian_Corto.mp3": 34777,
	"./Short_Polish_Krótki.mp3": 69607,
	"./Short_Portuguese_Curto.mp3": 84178,
	"./Short_Spanish_Corto.mp3": 96841,
	"./Shovel_French_Pelle.mp3": 64731,
	"./Shovel_German_Schaufel.mp3": 25620,
	"./Shovel_Italian_Pala.mp3": 1539,
	"./Shovel_Polish_Łopata.mp3": 89674,
	"./Shovel_Portuguese_Pá.mp3": 67791,
	"./Shovel_Spanish_Pala.mp3": 97419,
	"./Sister_French_Sœur.mp3": 19429,
	"./Sister_German_Schwester.mp3": 75034,
	"./Sister_Italian_Sorella.mp3": 40138,
	"./Sister_Polish_Siostra.mp3": 83392,
	"./Sister_Portuguese_Irmã.mp3": 27082,
	"./Sister_Spanish_Hermana.mp3": 97148,
	"./Six_French_Six.mp3": 47582,
	"./Six_German_Sechs.mp3": 56060,
	"./Six_Italian_Sei.mp3": 85697,
	"./Six_Polish_Sześć.mp3": 95255,
	"./Six_Portuguese_Seis.mp3": 47931,
	"./Six_Spanish_Seis.mp3": 30572,
	"./Skin_French_Peau.mp3": 5890,
	"./Skin_German_Haut.mp3": 15001,
	"./Skin_Italian_Pelle.mp3": 59509,
	"./Skin_Polish_Skóra.mp3": 55050,
	"./Skin_Portuguese_Pele.mp3": 28740,
	"./Skin_Spanish_Piel.mp3": 6247,
	"./Small_French_Petit.mp3": 20729,
	"./Small_German_Klein.mp3": 14960,
	"./Small_Italian_Piccolo.mp3": 52768,
	"./Small_Polish_Mały.mp3": 29079,
	"./Small_Portuguese_Pequeno.mp3": 98551,
	"./Small_Spanish_Pequeño.mp3": 9501,
	"./Smile_French_Sourire.mp3": 75025,
	"./Smile_German_Lächeln.mp3": 60336,
	"./Smile_Italian_Sorriso.mp3": 34698,
	"./Smile_Polish_Uśmiech.mp3": 8807,
	"./Smile_Portuguese_Sorriso.mp3": 95592,
	"./Smile_Spanish_Sonrisa.mp3": 46511,
	"./Snake_French_Serpent.mp3": 17483,
	"./Snake_German_Schlange.mp3": 45535,
	"./Snake_Italian_Serpente.mp3": 24102,
	"./Snake_Polish_Wąż.mp3": 54777,
	"./Snake_Portuguese_Cobra.mp3": 94182,
	"./Snake_Spanish_Serpiente.mp3": 5235,
	"./Sock_French_Chaussette.mp3": 22153,
	"./Sock_German_Socke.mp3": 19489,
	"./Sock_Italian_Calza.mp3": 89351,
	"./Sock_Polish_Skarpetka.mp3": 51335,
	"./Sock_Portuguese_Meia.mp3": 24375,
	"./Sock_Spanish_Calcetín.mp3": 39665,
	"./Soup_French_Soupe.mp3": 26135,
	"./Soup_German_Suppe.mp3": 71898,
	"./Soup_Italian_Minestra.mp3": 94356,
	"./Soup_Polish_Zupa.mp3": 67348,
	"./Soup_Portuguese_Sopa.mp3": 47189,
	"./Soup_Spanish_Sopa.mp3": 9672,
	"./South_French_Sud.mp3": 4167,
	"./South_German_Süd.mp3": 34762,
	"./South_Italian_Sud.mp3": 23679,
	"./South_Polish_Południe.mp3": 7244,
	"./South_Portuguese_Sul.mp3": 42392,
	"./South_Spanish_Sur.mp3": 50041,
	"./Spinach_French_Épinard.mp3": 91947,
	"./Spinach_German_Spinat.mp3": 72819,
	"./Spinach_Italian_Spinaci.mp3": 56973,
	"./Spinach_Polish_Szpinak.mp3": 81165,
	"./Spinach_Portuguese_Espinafre.mp3": 14818,
	"./Spinach_Spanish_Espinaca.mp3": 66662,
	"./Spoon_French_Cuillère.mp3": 94121,
	"./Spoon_German_Löffel.mp3": 47626,
	"./Spoon_Italian_Cucchiaio.mp3": 671,
	"./Spoon_Polish_Łyżka.mp3": 11230,
	"./Spoon_Portuguese_Colher.mp3": 50171,
	"./Spoon_Spanish_Cuchara.mp3": 84938,
	"./Strawberry_French_Fraise.mp3": 44535,
	"./Strawberry_German_Erdbeere.mp3": 35389,
	"./Strawberry_Italian_Fragola.mp3": 28057,
	"./Strawberry_Polish_Truskawka.mp3": 64361,
	"./Strawberry_Portuguese_Morango.mp3": 24030,
	"./Strawberry_Spanish_Fresa.mp3": 782,
	"./Study_French_Étude.mp3": 57318,
	"./Study_German_Studie.mp3": 59599,
	"./Study_Italian_Studio.mp3": 20403,
	"./Study_Polish_Badanie.mp3": 97718,
	"./Study_Portuguese_Estudar.mp3": 90534,
	"./Study_Spanish_Estudiar.mp3": 34404,
	"./Table_French_Table.mp3": 23182,
	"./Table_German_Tisch.mp3": 34429,
	"./Table_Italian_Tavolo.mp3": 58015,
	"./Table_Polish_Stół.mp3": 64225,
	"./Table_Portuguese_Mesa.mp3": 38325,
	"./Table_Spanish_Mesa.mp3": 55317,
	"./Taco_French_Tacos.mp3": 48201,
	"./Taco_German_Taco.mp3": 76372,
	"./Taco_Italian_Taco.mp3": 92594,
	"./Taco_Polish_Taco.mp3": 3339,
	"./Taco_Portuguese_Taco.mp3": 18023,
	"./Taco_Spanish_Tacos.mp3": 13169,
	"./Tea_French_Thé.mp3": 40569,
	"./Tea_German_Tee.mp3": 54448,
	"./Tea_Italian_Tè.mp3": 16934,
	"./Tea_Polish_Herbata.mp3": 73452,
	"./Tea_Portuguese_Chá.mp3": 80477,
	"./Tea_Spanish_Té.mp3": 41355,
	"./Teacher_French_Professeur.mp3": 51384,
	"./Teacher_German_Lehrer.mp3": 62796,
	"./Teacher_Italian_Insegnante.mp3": 71128,
	"./Teacher_Polish_Nauczyciel.mp3": 92318,
	"./Teacher_Portuguese_Professor.mp3": 62416,
	"./Teacher_Spanish_Maestro.mp3": 38997,
	"./Ten_French_Dix.mp3": 81858,
	"./Ten_German_Zehn.mp3": 36200,
	"./Ten_Italian_Dieci.mp3": 37871,
	"./Ten_Polish_Dziesięć.mp3": 84898,
	"./Ten_Portuguese_Dez.mp3": 51399,
	"./Ten_Spanish_Diez.mp3": 85427,
	"./Three_French_Trois.mp3": 41499,
	"./Three_German_Drei.mp3": 66204,
	"./Three_Italian_Tre.mp3": 63051,
	"./Three_Polish_Trzy.mp3": 68002,
	"./Three_Portuguese_Três.mp3": 15384,
	"./Three_Spanish_Tres.mp3": 37070,
	"./Toaster_French_Grille-pain.mp3": 86940,
	"./Toaster_German_Toaster.mp3": 35592,
	"./Toaster_Italian_Tostapane.mp3": 20521,
	"./Toaster_Polish_Opiekacz.mp3": 29855,
	"./Toaster_Portuguese_Torradeira.mp3": 42974,
	"./Toaster_Spanish_Tostadora.mp3": 7715,
	"./Tomato_French_Tomate.mp3": 55856,
	"./Tomato_German_Tomate.mp3": 38250,
	"./Tomato_Italian_Pomodoro.mp3": 33915,
	"./Tomato_Polish_Pomidor.mp3": 41183,
	"./Tomato_Portuguese_Tomate.mp3": 40769,
	"./Tomato_Spanish_Tomate.mp3": 80190,
	"./Tree_French_Arbre.mp3": 67844,
	"./Tree_German_Baum.mp3": 75481,
	"./Tree_Italian_Albero.mp3": 60365,
	"./Tree_Polish_Drzewo.mp3": 45552,
	"./Tree_Portuguese_Árvore.mp3": 19916,
	"./Tree_Spanish_Árbol.mp3": 14384,
	"./Triangle_French_Triangle.mp3": 7226,
	"./Triangle_German_Dreieck.mp3": 82035,
	"./Triangle_Italian_Triangolo.mp3": 35763,
	"./Triangle_Polish_Trójkąt.mp3": 60662,
	"./Triangle_Portuguese_Triângulo.mp3": 83221,
	"./Triangle_Spanish_Triángulo.mp3": 93265,
	"./Truck_French_Camion.mp3": 45158,
	"./Truck_German_Lastwagen.mp3": 16305,
	"./Truck_Italian_Camion.mp3": 66542,
	"./Truck_Polish_Ciężarówka.mp3": 86858,
	"./Truck_Portuguese_Caminhão.mp3": 45160,
	"./Truck_Spanish_Camión.mp3": 94122,
	"./Two_French_Deux.mp3": 93230,
	"./Two_German_Zwei.mp3": 14121,
	"./Two_Italian_Due.mp3": 26912,
	"./Two_Polish_Dwa.mp3": 88711,
	"./Two_Portuguese_Dois.mp3": 92346,
	"./Two_Spanish_Dos.mp3": 40252,
	"./Wallet_French_Portefeuille.mp3": 65109,
	"./Wallet_German_Portemonaie.mp3": 58018,
	"./Wallet_Italian_Portafoglio.mp3": 92037,
	"./Wallet_Polish_Portfel.mp3": 62293,
	"./Wallet_Portuguese_Carteira.mp3": 2479,
	"./Wallet_Spanish_Billetera.mp3": 26461,
	"./Want_French_Vouloir.mp3": 43748,
	"./Want_German_Wollen.mp3": 60597,
	"./Want_Italian_Volere.mp3": 91481,
	"./Want_Polish_Chcieć.mp3": 12832,
	"./Want_Portuguese_Querer.mp3": 55107,
	"./Want_Spanish_Desear.mp3": 22450,
	"./Water_French_Eau.mp3": 74802,
	"./Water_German_Wasser.mp3": 64618,
	"./Water_Italian_Acqua.mp3": 75086,
	"./Water_Polish_Woda.mp3": 80609,
	"./Water_Portuguese_Água.mp3": 30752,
	"./Water_Spanish_Agua.mp3": 95301,
	"./Watermelon_French_Pastèque.mp3": 1939,
	"./Watermelon_German_Wassermelone.mp3": 80103,
	"./Watermelon_Italian_Anguria.mp3": 90253,
	"./Watermelon_Polish_Arbuz.mp3": 93959,
	"./Watermelon_Portuguese_Melancia.mp3": 59825,
	"./Watermelon_Spanish_Sandía.mp3": 37330,
	"./Wheel_French_Roue.mp3": 77696,
	"./Wheel_German_Rad.mp3": 24482,
	"./Wheel_Italian_Ruota.mp3": 57206,
	"./Wheel_Polish_Koło.mp3": 26545,
	"./Wheel_Portuguese_Roda.mp3": 81230,
	"./Wheel_Spanish_Rueda.mp3": 41764,
	"./White_French_Blanc.mp3": 85853,
	"./White_German_Weiß.mp3": 24699,
	"./White_Italian_Bianco.mp3": 88321,
	"./White_Polish_Biały.mp3": 59223,
	"./White_Portuguese_Branco.mp3": 12271,
	"./White_Spanish_Blanco.mp3": 22980,
	"./Window_French_Fenêtre.mp3": 85936,
	"./Window_German_Fenster.mp3": 12547,
	"./Window_Italian_Finestra.mp3": 64690,
	"./Window_Polish_Okno.mp3": 32352,
	"./Window_Portuguese_Janela.mp3": 75506,
	"./Window_Spanish_Ventana.mp3": 62637,
	"./Yellow_French_Jaune.mp3": 78733,
	"./Yellow_German_Gelb.mp3": 12134,
	"./Yellow_Italian_Giallo.mp3": 31520,
	"./Yellow_Polish_Żółty.mp3": 15548,
	"./Yellow_Portuguese_Amarelo.mp3": 90490,
	"./Yellow_Spanish_Amarillo.mp3": 84731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31007;